export const SORT_TYPE = {
  DOCTOR_NAME_A_Z: "doctor_name_a_z",
  DOCTOR_NAME_Z_A: "doctor_name_z_a",
  DOCTOR_NAME_IN_OUT: "doctor_name_in_out",
  DOCTOR_NAME_OUT_IN: "doctor_name_out_in",
};

export const CONSULTATION_TYPE = {
  TELE_CONSULT_REGULAR: "0",
  TELE_CONSULT_FOLLOW_UP: "1",
  INSTANT: "2",
  IN_CLINIC_PROCEDURE: "4",
  IN_CLINIC_REGULAR: "5",
  IN_CLINIC_FOLLOW_UP: "6",
};
export const CONSULTATION_TYPE_VALUE = {
  TELE_CONSULT_REGULAR: "Tele Consult Regular",
  TELE_CONSULT_FOLLOW_UP: "Tele Consult Follow up",
  IN_CLINIC_REGULAR: "In clinic Regular",
  IN_CLINIC_FOLLOW_UP: "In clinic Follow up",
};

export const USER_TYPE = {
  DOCTOR: "doctor",
  STAFF: "staff",
};
export const DOCTOR_STATUS_DATA = [
  // dropdown values defined for sort
  {
    name: "Account Name (A-Z)",
    key: SORT_TYPE.DOCTOR_NAME_A_Z,
    selected: false,
  },
  {
    name: "Account Name (Z-A)",
    key: SORT_TYPE.DOCTOR_NAME_Z_A,
    selected: false,
  },
  {
    name: "Account's (In-Out)",
    key: SORT_TYPE.DOCTOR_NAME_IN_OUT,
    selected: false,
  },
  {
    name: "Account's (Out-In)",
    key: SORT_TYPE.DOCTOR_NAME_OUT_IN,
    selected: false,
  },
];
export const ALL_DOCS_RESOURCES = [
  //default dropdown values defined for filter
  {
    title: "All",
    value: "",
    selected: false,
  },
  {
    title: "Show Resources",
    value: 1,
    selected: false,
  },
  {
    title: "Show Doctors",
    value: 0,
    selected: false,
  },
];